import * as env from 'src/lib/env';
import * as log from 'src/lib/log';

const URL_INDEX = '/FE_METADATA.json';

const fetchFEBuildMetadata = () => {
  // Add timestamp to URL, to overcome "read from disk cache" issue
  const url = `${URL_INDEX}?t=${Date.now()}`;

  return fetch(url).then((response) => {
    if (!response.ok) {
      throw new Error('Error requesting FE build metadata file');
    }

    return response.json();
  });
};

// Staging keeps the same TAG while a feature is redeployed, so the commit is what tells those builds apart.
// Builds that lack a commit on either side fall back to the TAG alone.
const isSameBuild = (remoteMetadata) => {
  if (remoteMetadata.TAG !== env.getRepositoryTag()) {
    return false;
  }

  const localCommit = env.getCommitHash();
  const remoteCommit = remoteMetadata.commit;

  return !localCommit || !remoteCommit || remoteCommit === localCommit;
};

export function checkRemoteBuild(onResult) {
  fetchFEBuildMetadata()
    .then((remoteMetadata) => {
      onResult(isSameBuild(remoteMetadata));
    })
    .catch((error) => {
      log.warning(`Failed to check FE relevance: ${error?.message}`);
    });
}
